import { render, staticRenderFns } from "./ModalResults.vue?vue&type=template&id=f6a2817a&scoped=true&"
import script from "./ModalResults.vue?vue&type=script&lang=js&"
export * from "./ModalResults.vue?vue&type=script&lang=js&"
import style0 from "./ModalResults.vue?vue&type=style&index=0&id=f6a2817a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a2817a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
